<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header pb-0">Marginal Risk Contribution</div>
            <div class="card-body pt-0">
                <highcharts-chart
                        [options]="chartOptions"
                        style="width: 100%; height: auto; display: block;"
                ></highcharts-chart>
            </div>
        </div>
    </div>
</div>

